'use client';

import { sendEvent } from '@/lib/firebase/analytics/sendEvent';
import type { Events } from '@/lib/firebase/analytics/events';
import { useEffect } from 'react';

type Props = {
  eventName: Events;
  params?: { [key: string]: string | number | boolean };
};

// NOTE: firebase analyticsのイベントがサーバー側(SSR)からは発火できないため
//       ページ遷移時にクライアントからイベント発火するためだけのコンポーネント
export default function FirebasePageViewEvent({
  eventName,
  params = {}
}: Props) {
  useEffect(() => {
    (async () => {
      await sendEvent(eventName, { ...params });
    })();
  }, [eventName, params]);
  return <></>;
}
